// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Col, Form, Image, Button, Modal } from "react-bootstrap";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  Logo,
  showPwdImg,
  hidePwdImg,
  FavLogo,
  Check,
  LoginVideo,
} from "../assets/img";
import LogInFooter from "../logincomponent/LogInFooter";
import LogInConnect from "../logincomponent/LogInConnect";
import useToken from "../constants/Storage/useToken";
import { api } from "../constants/Services";
import ErrorModel from "../constants/Services/Api/errorModel";
const SetPassword = () => {
  const { token, setToken } = useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const emailId = location?.state?.data?.user?.SPUD_email;
  const userName = location?.state?.data?.user?.SPUD_UserName;
  // console.log(location);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isConPwd, setIsConPwd] = useState(false);
  const [cpwd, setCpwd] = useState("");
  const [name, setName] = useState("");
  const [name2, setName2] = useState("");
  const [name3, setName3] = useState("");
  const [pwd, setPwd] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [passErr, setPassErr] = useState(false);
  const [confirmPassErr, setConfirmPassErr] = useState(false);
  const [list, setList] = useState([]);
  const [list2, setList2] = useState([]);
  const [emails, setEmails] = useState("");

  const [RegSuccessModal, setRegSuccessModal] = useState(false);

  const [error, setError] = useState();
  const [errorBox, setErrorBox] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const tokenData = searchParams?.get("token");

  const tokenType = searchParams?.get("type");

  const [errorMessage, setErrorMessage] = useState("");

  // console.log(tokenType);
  // console.log(tokenData);

  const tokenVerificate = () => {
    api.tokenVerify(tokenData).then((res) => {
      if (res?.status == "success") {
        setList(res?.supplier);
        setList2(res?.sup_user);
        setName(res?.supplier?.email);
        setName2(res?.sup_user?.user_name);
        setName3(res?.sup_user?.email);
        setEmails(res?.sup_user?.CompanyEmail);
        setError(res);
        setErrorBox(true);
      } else {
        setError(res);
        setErrorBox(true);
        setTimeout(() => {
          navigate("/register");
        }, 1500);
      }
    });
  };

  const errorModalClose = () => {
    setErrorBox(!errorBox);
  };

  // console.log(list);

  const acceptReject = () => {
    let data = {
      user_name: userName,
      status: 1,
    };
    api.accept_reject(data).then((res) => {
      console.log(res);
    });
  };

  useEffect(() => {
    if (tokenData) {
      tokenVerificate();
    }
  }, []);

  const handlePassword = (event) => {
    let new_pass = event.target.value;
    if (new_pass?.length !== 0) {
      setPwd(new_pass);

      // regular expressions to validate password
      var lowerCase = /[a-z]/g;
      var upperCase = /[A-Z]/g;
      var numbers = /[0-9]/g;
      if (!new_pass.match(lowerCase)) {
        setErrorMessage("Password should contains lowercase letters!");
      } else if (!new_pass.match(upperCase)) {
        setErrorMessage("Password should contain uppercase letters!");
      } else if (!new_pass.match(numbers)) {
        setErrorMessage("Password should contains numbers also!");
      } else if (new_pass.length < 8) {
        setErrorMessage("Password length should be more than 8.");
      } else {
        // setErrorMessage("Password is strong!");
        setErrorMessage("");
      }
    } else {
      setErrorMessage("");
      setPwd(new_pass);
    }
  };

  const submitHandle = () => {
    // console.log("poiss");
    if (name?.length == 0 || pwd?.length == 0) {
      setNameErr(true);
      setPassErr(true);
      // console.log("rtyu");
    } else if (cpwd?.length < 8) {
      setConfirmPassErr(true);
      // console.log("rtysu");
    } else if (errorMessage?.length == 0) {
      let forGot = {
        user_name: name2,
        password: pwd,
        password_confirmation: cpwd,
        token: tokenData,
      };

      if (tokenType == "forgot-pasword") {
        api.setPass(forGot).then((res) => {
          if (res?.status == "success") {
            // acceptReject();
            setError(res);
            setErrorBox(true);
            setRegSuccessModal(true);
          } else {
            setError(res);
            setErrorBox(true);
          }
        });
      } else {
        if (list2 !== null) {
          let supdata = {
            user_name: name2,
            password: pwd,
            password_confirmation: cpwd,
            token: tokenData,
          };

          api.setPass(supdata).then((res) => {
            if (res?.status == "success") {
              // acceptReject();
              setError(res);
              setErrorBox(true);
              setRegSuccessModal(true);
            } else {
              setError(res);
              setErrorBox(true);
            }
          });
        } else {
          let data = {
            first_name: list?.first_name,
            last_name: list?.last_name,
            mobile: list?.phone,
            user_name: name,
            password: pwd,
            password_confirmation: cpwd,
            email: list?.email,
            token: tokenData,
          };
          api.setPassword(data).then((res) => {
            if (res?.status == "success") {
              // acceptReject();
              setError(res);
              setErrorBox(true);
              setRegSuccessModal(true);
            } else {
              setError(res);
              setErrorBox(true);
            }
          });
        }
      }
    }
  };

  return (
    <div className="login-bg">
      {errorBox && (
        <ErrorModel
          error={error}
          errorBox={errorBox}
          errorModalClose={errorModalClose}
        />
      )}
      <div className="video-bg-setpass">
        <video autoPlay loop muted className="">
          <source src={LoginVideo} type="video/mp4" />
        </video>
        <div className="d-flex-al-jc log_cent">
          <Col md={6} sm={8} xs={12} lg={4} xl={3} className="">
            <div className="form_box">
              <Image src={Logo} />
              <h6>Welcome to Supplier Portal34343</h6>
              <Col xs={12} className="my-2 position-relative pwd-container">
                <input
                  className="form-control bg-transparent"
                  type="name"
                  placeholder="Company Email"
                  onChange={(e) => setName(e.target.value)}
                  value={name || name3}
                  // disabled
                />
                {name?.length == 0 && nameErr && (
                  <p className="err-input pe-0 mb-0">
                    Enter the Company Email ID
                  </p>
                )}
              </Col>
              <Col
                xs={12}
                className="bg-transparent my-2 mt-3 position-relative pwd-container"
              >
                <input
                  name="pwd"
                  className="form-control"
                  placeholder="Enter Password"
                  type={isRevealPwd ? "text" : "password"}
                  value={pwd}
                  onChange={handlePassword}
                />
                <Image
                  type={isRevealPwd ? "text" : "password"}
                  src={isRevealPwd ? showPwdImg : hidePwdImg}
                  onClick={() => setIsRevealPwd((prevState) => !prevState)}
                />
                {pwd?.length == 0 && passErr && (
                  <p className="err-input pe-0 mb-0">Enter Password</p>
                )}
                {errorMessage && (
                  <p className="err-input" style={{ bottom: "-32px" }}>
                    {errorMessage}
                  </p>
                )}
              </Col>
              <Col
                xs={12}
                className="bg-transparent my-2 mt-3 position-relative pwd-container"
              >
                <input
                  name="pwd"
                  className="form-control"
                  placeholder="Confirm Password"
                  type={isConPwd ? "text" : "password"}
                  value={cpwd}
                  onChange={(e) => setCpwd(e.target.value)}
                />
                <Image
                  title={isConPwd ? "Hide password" : "Show password"}
                  src={isConPwd ? showPwdImg : hidePwdImg}
                  onClick={() => setIsConPwd((prevState) => !prevState)}
                />
                {cpwd?.length == 0 && confirmPassErr && (
                  <p className="err-input pe-0 mb-0">Enter Confirm Password</p>
                )}
                {pwd !== cpwd && cpwd?.length !== 0 && (
                  <p className="err-input pe-0 mb-0">Password Mismatch</p>
                )}{" "}
              </Col>

              <button
                style={{ background: "#247395" }}
                onClick={submitHandle}
                className="bt-tx"
              >
                Set Password
              </button>
              <LogInConnect />
            </div>
          </Col>
          <div className="mt-3  ">
            <Modal
              id="#sucess"
              className="otp-modal"
              show={RegSuccessModal}
              size="md"
              centered
              onHide={() => setRegSuccessModal(false)}
              aria-labelledby="contained-modal-title-vcenter"
            >
              <div className="sup-modal ">
                <Image className="fav-icon" src={FavLogo} />
                <div className="mt-0">
                  <div className="d-flex-as-jc img_tick ">
                    <Image src={Check} />
                    <div className="px-3">
                      <h5>Registration Successfully</h5>
                      <p>You can now login to your KH account</p>
                    </div>
                  </div>
                  <Link
                    className="my-3 cust-btn mx-auto d-flex bg-primary1 text-white py-2 text-center"
                    style={{ width: "63px" }}
                    to={"/logIn"}
                  >
                    Login
                  </Link>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
      <LogInFooter />
    </div>
  );
};
export default SetPassword;
